var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"media",attrs:{"id":"media"}},[(_vm.loading)?_c('div',{staticClass:"text-center"},[_c('v-progress-circular',{attrs:{"size":60,"color":"primary","indeterminate":""}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }